import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useMedia } from 'sb-hooks'
import cx from 'classnames'

import Link from 'components/ui/Link/Link'
import { UpchargePrice, Loader, ImageWithPlaceholderFallback } from 'components/_new/ui'
import ProductLabels from 'components/product/ProductLabels/ProductLabels'

import s from './ProductImage.scss'


const ProductImage = (props) => {
  const { className, src, w, mW, link, withMicrodata, labels, upchargePrice, toOLD, onClick } = props

  const { isMobile } = useMedia()

  const isLink  = link || toOLD
  const node    = isLink ? Link : 'div'

  const nodeProps = {
    className: cx(s.container, className),
    to: link,
    onClick,
  }

  if (toOLD) { // fix propTypes warning in console (productPage)
    nodeProps.toOLD = toOLD
  }

  return React.createElement(
    node,
    nodeProps,
    Boolean(labels) && (
      <ProductLabels className={s.labels} items={labels} />
    ),
    <Fragment>
      <Loader className={s.loader} />
      <ImageWithPlaceholderFallback
        key={src}
        className={s.image}
        src={src}
        w={isMobile ? mW : w}
        x2
        x3
        resizeBy="width"
        alt="product"
        {...(withMicrodata && { itemProp: 'image' })}
      />
    </Fragment>,
    Boolean(upchargePrice) && (
      <UpchargePrice className={s.upchargePrice} price={upchargePrice} size="md" />
    )
  )
}

ProductImage.propTypes = {
  src: PropTypes.string,
  link: PropTypes.string,
  labels: PropTypes.array,
  withMicrodata: PropTypes.bool,
  upchargePrice: PropTypes.number,
}


export default ProductImage
